import type { ComponentPropsWithRef, FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Button } from '../Button'
import { HeartIcon } from '../Icons/Miscellaneous/Heart'
import styles from './SaveButton.module.scss'

export const SaveButton: FunctionComponent<Props> = ({
  selected,
  className,
  dataWhichId,
  productName,
  onClick,
  pulsate = false,
  ...rest
}) => {
  return (
    <Button
      type="button"
      aria-label={`${
        selected
          ? `remove ${productName} from saved products`
          : `save product ${productName}`
      }`}
      className={classnames(
        className,
        selected ? styles.heartSelected : styles.heartUnselected
      )}
      data-testid="save-button"
      {...(dataWhichId && { 'data-which-id': dataWhichId })}
      onClick={onClick}
      {...rest}
    >
      <HeartIcon
        data-testid={`heart-icon-${selected ? 'selected' : 'unselected'}`}
        selected={selected}
        width={16}
        height={16}
      />
      {pulsate && (
        <span className={styles.pulseEffect} data-testid="pulse-effect" />
      )}
    </Button>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  /**
   * Has the heart icon been clicked by the user?
   */
  selected: boolean
  /**
   * Product name used within the aria-label to make sure it's unique
   */
  productName: string
  /**
   * Function to handle selecting/deselecting the heart icon
   */
  onClick: () => void
  /**
   * Optional class name for additional styling on the button element
   */
  className?: string
  /**
   * Optional pulse effect animation
   */
  pulsate?: boolean
  dataWhichId?: string
} & ComponentPropsWithRef<'button'>
